import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/contexts/LanguageContext";
import { AuthProvider } from "@/contexts/AuthContext";
import Layout from "@/components/layout/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Projects from "@/pages/Projects";
import News from "@/pages/News";
import Donate from "@/pages/Donate";
import Contact from "@/pages/Contact";
import Impressum from "@/pages/Impressum";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/components/admin/AdminLayout";
import ProtectedRoute from "@/components/admin/ProtectedRoute";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminContacts from "@/pages/admin/AdminContacts";
import AdminNewsletter from "@/pages/admin/AdminNewsletter";
import AdminMemberships from "@/pages/admin/AdminMemberships";
import AdminDonations from "@/pages/admin/AdminDonations";

export default function App() {
    return (
        <div className="App">
            <AuthProvider>
                <LanguageProvider>
                    <BrowserRouter>
                        <Routes>
                            {/* Public site */}
                            <Route element={<Layout />}>
                                <Route path="/" element={<Home />} />
                                <Route path="/about" element={<About />} />
                                <Route path="/projects" element={<Projects />} />
                                <Route path="/news" element={<News />} />
                                <Route path="/donate" element={<Donate />} />
                                <Route path="/contact" element={<Contact />} />
                                <Route path="/impressum" element={<Impressum />} />
                            </Route>

                            {/* Admin */}
                            <Route path="/admin/login" element={<AdminLogin />} />
                            <Route element={<ProtectedRoute />}>
                                <Route element={<AdminLayout />}>
                                    <Route path="/admin" element={<AdminDashboard />} />
                                    <Route path="/admin/donations" element={<AdminDonations />} />
                                    <Route path="/admin/memberships" element={<AdminMemberships />} />
                                    <Route path="/admin/contacts" element={<AdminContacts />} />
                                    <Route path="/admin/newsletter" element={<AdminNewsletter />} />
                                </Route>
                            </Route>
                        </Routes>
                    </BrowserRouter>
                </LanguageProvider>
            </AuthProvider>
        </div>
    );
}
